import React, { Component } from 'react'
import './index.scss'
import Axios from '../../request'
import { Toast, Modal } from 'antd-mobile'
export default class TopicDialog extends Component {
  state = {
    showModal: false,
    title: '',
    options: [],
  }
  show = () => {
    this.setState({ showModal: true })
  }
  close = () => {
    this.setState({ showModal: false })
  }
  getQuestionsData = () => {
    Axios.jsonp({ url: `/api/vote/option/list/${this.props.topicId}?numType=1` }).then(
      (res) => {
        console.log(res);
        this.setState({
          // title: `关于 ${res[0].name.split('&')[0]}：`,
          options: res.map((item) => ({
            id: item.id,
            checked: false,
            title: item.name,
          })),
        })
      }
    )
  }
  submitAnswer = () => {
    const { options } = this.state
    let optionChecked = options.filter((item) => item.checked)
    let optionCheckedIds = optionChecked.map((item) => item.id)
    if (optionCheckedIds.length === 0) {
      Toast.fail('至少选择一个选项', 1.5)
      return false
    }
    Axios.jsonp({
      url: `/api/vote/${this.props.topicId}/?id=${this.props.topicId}&options=${optionCheckedIds.join(
        ','
      )}`,
    }).then((res) => {
      if (res.result === 200) {
        Toast.success('提交成功', 1.5, () => {
          this.close()
          options.map((item) => {
            item.checked = false
            return item
          })
          this.setState({ options })
        })
      } else {
        Toast.fail(res.msg, 1.5)
      }
    })
  }
  changeCheck = (index) => {
    return (e) => {
      const { options } = this.state
      options[index].checked = e.target.checked
      this.setState({ options })
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.topicId !== this.props.topicId) this.getQuestionsData()
  }
  render() {
    const { showModal, title, options } = this.state
    const { topicName } = this.props
    return (
      <Modal
        className="dialogBox"
        visible={showModal}
        transparent
        closable={true}
        maskClosable={false}
        title={topicName}
        onClose={this.close}
      >
        <ul className="questionsList">
          <li className="questionsItem">
            <div className="title">关于{topicName}，您最关心的问题是：</div>
            {/* <div className="title">{title}</div> */}
            {options.map((item, index) => (
              <div className="optionsBox" key={item.id}>
                <input
                  className="checkBox"
                  type="checkbox"
                  id={item.id}
                  checked={item.checked}
                  onChange={this.changeCheck(index)}
                />
                <label className="text" htmlFor={item.id}>
                  {item.title}
                </label>
              </div>
            ))}
          </li>
          <button className="submitBtn" onClick={this.submitAnswer}>
            提交
          </button>
        </ul>
      </Modal>
    )
  }
}
